import { Permission } from './permission';
import { Role } from './role';

export class RolePermissions {
    permissionsID = [];
    roleID: number;
}
